import React, { PureComponent } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { connect } from 'react-redux';
import { Avatar, Input, message } from 'antd';
import CusUpload from '../../cusUpload/CusUpload';
import Util from '../../../script/util';
import HTTP from '../../../script/service';
import './step2.scss';

class Step2 extends PureComponent {
  state = {
    sex: 0,

    nickName: '', // 用户呢称
    avatarUrl: '', // 头像 URL

    avatarList: [], // 当前头像列表
    manAvatarList: [], // 男头像列表
    wManAvatarList: [], // 女头像列表
    posIndexArr: [], // 头像对应的索引
    selectAvatarIndex: null, // 当前选择的头像
  };

  getState = () => {
    const { nickName, avatarUrl } = this.state;
    return { nickName, avatarUrl };
  };

  // 初始化数据
  initStep2Data = (sex = 0) => {
    this.setState({ sex });
    this.getDefaultAvatar();
  };

  // 判断按钮状态
  setBtnStatus = () => {
    const { nickName, avatarUrl } = this.state;

    if (!checkAsString(nickName) && avatarUrl != null && !!avatarUrl) {
      this.props.nextBtnStatus(false, '完成');
    } else {
      this.props.nextBtnStatus(true, '完成');
    }

    function checkAsString(str) {
      return !(typeof str === 'string' && str.trim().length);
    }
  };
  // 上传头像
  uploadAvatar = (files) => {
    if (files) {
      const picPc = files.center;
      this.setState({ avatarUrl: picPc, selectAvatarIndex: null }, () => {
        this.setBtnStatus();
      });
    }
  };
  clickAvatarItem = (item, index) => {
    this.setState({ avatarUrl: item.picPc, selectAvatarIndex: index }, () => {
      this.setBtnStatus();
    });
  };
  // 获取随机用户呢称
  getRandomNickName = () => {
    const { sex } = this.state;
    if (sex != null) {
      const params = { sex };
      HTTP._get_random_nick_name(params).then((res) => {
        if (res && res.code === 200) {
          this.setState({ nickName: res.data }, () => {
            this.setBtnStatus();
          });
        }
      });
    }
  };
  // 头像列表
  setSexAvatarList = (list, sex) => {
    const avatarList = [];
    const setList = list.filter((item) => item.sex === sex);
    const centerIndex = Math.floor(setList.length / 2);
    setList.forEach((item, i) => {
      let index = i + 1;
      if (index > centerIndex) {
        index = index + 1;
      }
      avatarList.push({ ...item, id: index });
    });
    return avatarList;
  };
  // 初始化头像
  setAvatarList = () => {
    const { sex, manAvatarList, wManAvatarList } = this.state;
    let avatar = [];
    if (sex == null) {
      avatar = [...manAvatarList, ...wManAvatarList];
    } else if (sex === 0) {
      avatar = manAvatarList;
    } else if (sex === 1) {
      avatar = wManAvatarList;
    }
    const avatarList = avatar.map((item, index) => ({
      ...item,
      id: index + 1,
    }));
    const posIndexArr = avatar.map((item, index) => index + 1);
    this.setState({ avatarList, posIndexArr }, () => {
      this.getRandomNickName();
    });
  };

  // 姓名输入
  handleChangeName = (e) => {
    let { value } = e.target;
    if (value != null) {
      value = value.replace(/\s/g, '');
    }
    this.setState({ nickName: value }, () => {
      this.setBtnStatus();
    });
  };
  // 获取新的昵称
  handleRefreshNickname = () => {
    const { sex } = this.state;
    if (sex == null) {
      message.warning('请先选择性别哦~');
      return;
    }
    this.getRandomNickName();
  };

  // 获取用户头像
  getDefaultAvatar = () => {
    HTTP._get_default_avatar()
      .then((res) => {
        if (res && res.code === 200) {
          const { data } = res;
          const manAvatarList = this.setSexAvatarList(data, 0);
          const wManAvatarList = this.setSexAvatarList(data, 1);

          this.setState({ manAvatarList, wManAvatarList }, () => {
            this.setAvatarList();
          });
        }
        this.setState({ loading: false });
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };

  // 上传头像组件
  uploadAvatarCom = () => {
    const { base } = this.props;
    const { avatarUrl, avatarList, selectAvatarIndex } = this.state;

    // 请求头部添加参数
    const uploadHeader = {
      authorization: base.token,
      uid: base.uid,
    };

    // 上传图片限制
    const beforeUpload = (file) => {
      return new Promise((resolve, reject) => {
        const isJpg = file.type === 'image/jpeg';
        if (!isJpg) {
          message.error('只支持JGP图片');
          reject(false);
        }
        if (file.size > 1024 * 1024 * 2) {
          message.error(`上传失败，图片大小不能超过${2}MB`);
          reject(false);
        }
        resolve(true);
      });
    };

    return (
      <div className="select-avatar-wrap">
        <div className="select-avatar">
          <CusUpload
            size={2}
            className="avatar-img"
            listType="picture-card"
            headers={uploadHeader}
            beforeUpload={beforeUpload}
            onChange={this.uploadAvatar}
          >
            {avatarUrl ? (
              <>
                <img src={Util.transImgUrl(avatarUrl)} alt="" />
                <div className="icon-upload-avatar" />
              </>
            ) : (
              <i className="icon-add" />
            )}
          </CusUpload>
        </div>
        <p className="avatar-tip">上传头像或选择一个默认头像</p>
        <ul className="avatar-list">
          {avatarList &&
            !!avatarList.length &&
            avatarList.map((n, i) => (
              <li
                key={n.id}
                className={`item-select ${selectAvatarIndex === i ? 'active' : ''}`}
                onClick={() => this.clickAvatarItem(n, i)}
              >
                <Avatar
                  size={48}
                  src={Util.transImgUrl(n.picPc, '48x48')}
                  alt=""
                />
              </li>
            ))}
        </ul>
      </div>
    );
  };

  render() {
    const { nickName } = this.state;
    return (
      <div className="perfect-step-2">
        <div className="step-header">
          <h2 className="step-title">请选择你的头像&昵称</h2>
        </div>
        {this.uploadAvatarCom()}

        <Input
          className="name-input"
          placeholder="取一个酷炫的昵称吧"
          value={nickName}
          onChange={this.handleChangeName}
          maxLength={9}
          autoComplete="off"
          suffix={
            <span
              onClick={this.handleRefreshNickname}
              className="name-input-suffix"
            />
          }
        />
        <p className="input-tip noSelect">
          最多可输入9个字符，支持中英文、数字、表情符号
        </p>
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(Step2, { withRef: true })
);
